import { createSlice } from '@reduxjs/toolkit';
import { setLoader } from './commonSlice';
import { fetcherGet, fetcherPut, fetcherPost } from "../utils/fetcher";
import { APIS, isEmpty } from "../utils/constants";

const initialState = {
    payoutMentors: [],
    recentActivity: [],
    administratorsList: [],
    schoolAdminActivity: []
}

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        setPayoutMentors: (state, action) => {
            state.payoutMentors = action.payload;
        },
        setRecentActivityCount: (state, action) => {
            state.recentActivity = action.payload;
        },
        setAdministratorsList: (state, action) => {
            state.administratorsList = action.payload
        },
        setSchoolAdminActivity:(state, action) => {
            state.schoolAdminActivity = action.payload
        }
    }
});

export function checkPayoutEnabled() {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS.CHECK_PAYOUTS_ENABLED)
            .then(() => {
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getMentorsPayout(param) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let apiUrl = APIS.GET_MENTORS_PAYOUT;
        apiUrl += param ? param + '&' : '?';
        apiUrl += `timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}&limit=200`;

        fetcherGet(apiUrl)
            .then((res) => {
                dispatch(setPayoutMentors(res?.data));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function removeService(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.REMOVE_SERVICES, payload)
            .then((res) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(res?.data);
                }
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getRecentActivityCount(){
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS?.GET_RECENT_COUNT)
        .then((res)=> {
            dispatch(setRecentActivityCount(res?.data))
            dispatch(setLoader(false));
        })
        .catch(()=> {
            dispatch(setLoader(false));
        })
    }
}

export function payToMentorInBulk(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.PAY_TO_MENTOR_IN_BULK, payload)
            .then((res) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(res?.data?.sessionId, true);
                }
                dispatch(setLoader(false));
            })
            .catch((err) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(err?.response?.data, false);
                }
                dispatch(setLoader(false));
            });
    };
}

export function payToMentorByServices(payload, callBack) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPost(APIS?.PAY_TO_MENTOR_BY_SERVICES, payload)
            .then((res) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(res, true);
                }
                dispatch(setLoader(false));
            })
            .catch((err) => {
                if (callBack && typeof callBack === 'function') {
                    callBack(err?.response?.data, false);
                }
                dispatch(setLoader(false));
            });
    };
}

export function getAdministratorsList(page = 1, searchQuery, limit=10, page_flag) {
    return (dispatch) => {
        dispatch(setLoader(true));
        let url = `${APIS.GET_ALL_ADMINISTRATORSLIST}${page}`;
        if(page_flag?.length){
            url=url+`&page_flag=${page_flag}`;
        }
        if (searchQuery?.length) {
            url = url + `&search=${searchQuery}`
        }
        url = url + `&limit=${limit}`
        fetcherGet(url)
            .then((response) => {
                const allAdministratorsList = !isEmpty(response?.data) ? response?.data : {};
                dispatch(setAdministratorsList(allAdministratorsList));
                dispatch(setLoader(false));
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}
 
export function updateCredits(payload, handlePopUp, msg) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.PUT_CREDITS, payload)
            .then(() => {
                dispatch(setLoader(false));
                if(msg){
                    handlePopUp(msg);
                }
            })
            .catch(() => {
                dispatch(setLoader(false));
            });
    };
}

export function getSchoolAdminRecentActivity(){
     return (dispatch) => {
        dispatch(setLoader(true));
        fetcherGet(APIS?.SCHOOL_ADMIN_RECENT_ACTIVITY)
            .then((res)=> {
                dispatch(setSchoolAdminActivity(res.data))
                dispatch(setLoader(false));
            }).then(()=>{
               dispatch(setLoader(false)); 
            })
     }
}
export function updateStudentCredits(payload, handlePopUp, msg) {
    return (dispatch) => {
        dispatch(setLoader(true));
        fetcherPut(APIS?.PUT_STUDENT_CREDITS, payload)
            .then(() => {
                dispatch(setLoader(false));
                if(msg){
                    handlePopUp(msg);
                }
            })
            .catch((error) => {
                if(error?.response?.data?.data?.message){
                    handlePopUp(error?.response?.data?.data?.message, error?.response?.data?.data?.data);
                }
                dispatch(setLoader(false));
            });
    };
}

export const { setPayoutMentors, setRecentActivityCount, setAdministratorsList, setSchoolAdminActivity } = adminSlice.actions;
export default adminSlice.reducer;